import React from 'react';
import ReactDOM from 'react-dom';
import { MakePaymentComponent } from "./MakePaymentComponent";
import { MakePifPaymentComponent } from "./MakePifPaymentComponent";
import { BookPhotoshootComponent } from "./BookPhotoshootComponent";
import { BookOneOnOneComponent } from "./BookOneOnOneComponent";
import { BookEventComponent } from "./BookEventComponent";
import { AddScheduledEventLocationComponent } from "./AddScheduledEventLocationComponent";
import { TalentNotificationsComponent } from "./TalentNotificationsComponent";
import { TalentNotificationsProfileComponent } from "./TalentNotificationsProfileComponent";
import { UpdateRecurringPaymentsComponent } from "./UpdateRecurringPaymentsComponent";
import { UpdateRecurringPaymentsPageComponent } from "./UpdateRecurringPaymentsPageComponent";

const initProps = window.initProps;

window.EntryPoint = {
    MakePifPaymentComponent,
    MakePaymentComponent,
    BookPhotoshootComponent,
    BookOneOnOneComponent,
    AddScheduledEventLocationComponent,
    TalentNotificationsComponent,
    UpdateRecurringPaymentsComponent,
    UpdateRecurringPaymentsPageComponent,
    TalentNotificationsProfileComponent,
    BookEventComponent,
    React,
    ReactDOM
}